// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"03004211","772":"1a0d302d","830":"3b0459b9"}[chunkId] + ".chunk.css";
};